<template>
    <div class="day-popup tooltip-day tooltip-container visible hovered" v-if="show" :style="style">
        <div class="person-popup__details">
            <table>
                <template v-if="schedule">
                    <tr>
                        <td>{{ trans('Date') }}:</td>
                        <td>{{ eventValues.date.localDate }}</td>
                    </tr>
                    <!-- Default weekschedule exists or mode is task  -->
                    <tr>
                        <td>{{ trans('Schedule') }}:</td>
                        <td>
                            <div
                                v-if="schedule.schedule.color"
                                class="schedule-title-circle"
                                :style="{
                                    'background-color': schedule.schedule.color,
                                }"
                            ></div>
                            {{ schedule.schedule.title }}
                            <!--                            <span class="owner-text">{{ trans('Company') }}</span>-->
                        </td>
                    </tr>
                    <tr v-if="schedule.time_start">
                        <td>{{ trans('Start') }}:</td>
                        <td>{{ schedule.time_start }}</td>
                    </tr>
                    <tr v-if="schedule.time_duration">
                        <td>{{ trans('Working time') }}:</td>
                        <td>
                            {{ schedule.time_duration }}
                        </td>
                    </tr>
                </template>

                <template v-if="absences.length > 0">
                    <!-- If defaultAbsences exists -->
                    <tr>
                        <td>{{ trans('Absences') }}:</td>
                        <td>
                            <div class="row" v-for="absence of absences">
                                <div class="col-12">
                                    <div
                                        v-if="absence.type.color"
                                        class="schedule-title-circle"
                                        :style="{ 'background-color': absence.type.color }"
                                    ></div>
                                    {{ absence.type.title }}
                                    <!--                                    <span class="owner-text">{{ absence.owner_text }}</span>-->
                                </div>
                                <div class="col-12">
                                    <small>{{ absence.time_start }} - {{ absence.time_end }}</small>
                                </div>
                            </div>
                        </td>
                    </tr>
                </template>
                <tr v-if="capacity && capacity[date]">
                    <td>{{ trans('Capacity') }}:</td>
                    <td>
                        {{ getCapacityTime(capacity[date]) }}
                        <span v-if="getCapacityPercentage(capacity[date])"
                            >({{ getCapacityPercentage(capacity[date]) }}%)</span
                        >
                        <span
                            class="badge"
                            :style="capacityBadgeColor(capacity[date])"
                            v-if="getCapacityRange(capacity[date])"
                            >{{ getCapacityRange(capacity[date]) }}</span
                        >
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import { emitter } from '../../../plugins/Mitt';
import { getCapacityTime } from '../../../utils/capacity/getCapacityTime';
import { getCapacityColor } from '../../../utils/capacity/getCapacityColor';
import { getCapacityPercentage } from '../../../utils/capacity/getCapacityPercentage';

let showDayHoverInfoTimer;

const CancelToken = axios.CancelToken;
let cancel;

function initialEventValuesState() {
    return {
        // The values passed by the event. The object is overwritten
        eventValues: {
            // All possible values
            personId: null,
            teamId: null,
            taskId: null,
            date: null,
            mode: null,
        },
    };
}

export default {
    data() {
        return {
            ...initialEventValuesState(),
            posY: 0,
            posX: 0,
            show: false,
            schedule: {},
            absences: {},
            capacity: {},
        };
    },
    computed: {
        style() {
            return {
                top: this.posY + 'px',
                left: this.posX + 'px',
            };
        },
    },
    methods: {
        getCapacityTime,
        getCapacityPercentage,
        capacityBadgeColor(capacity) {
            return {
                backgroundColor: getCapacityColor(capacity),
            };
        },
        getCapacityRange(capacity) {
            const color = getCapacityColor(capacity);
            switch (color) {
                case '#FFCCCC':
                    return '> 100%';
                case '#BBFFDD':
                    return '100%';
                case '#99FF99':
                    return '80% - 100%';
                default:
                    return false;
            }
        },
        showHoverInfo(event) {
            const targetPosition = event.target.getBoundingClientRect();
            this.posX = targetPosition.left + 20;
            this.posY = targetPosition.bottom;

            this.show = true;
            this.calculate(targetPosition);
        },
        getInfoForDayHoverComponent(event) {
            const eventValues = this.eventValues;
            const mode = eventValues.mode;
            const date = eventValues.date.formatted;
            let entityType = 'person';
            let entityId = eventValues.personId;
            if (mode === 'project') {
                entityType = 'company';
                entityId = null;
            } else if (mode === 'team') {
                entityType = 'team';
                entityId = eventValues.teamId;
            }
            const url = route('planning.get-data-for-day-hover-component');
            axios
                .get(url, {
                    params: {
                        mode: mode,
                        date: date,
                        entityType: entityType,
                        entityId: entityId,
                    },
                    cancelToken: new CancelToken(function executor(c) {
                        // An executor function receives a cancel function as a parameter
                        cancel = c;
                    }),
                })
                .then((response) => {
                    this.schedule = response.data.schedule;
                    this.absences = response.data.absences;
                    // this.capacity = response.data.capacity[this.eventValues.personId];
                    this.showHoverInfo(event);
                })
                .catch(() => {});
        },
        calculate(targetPosition) {
            this.$nextTick(() => {
                const box = document.querySelector('.day-popup');
                if (!box) {
                    return;
                }
                const rect = box.getBoundingClientRect();
                const isInViewport =
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth);

                if (!isInViewport) {
                    this.posX = targetPosition.left + 20;
                    this.posY = targetPosition.top;
                    if (rect.right > (window.innerWidth || document.documentElement.clientWidth)) {
                        box.classList.add('popup-side-left');
                        this.posY = targetPosition.top + 20;
                    } else {
                        box.classList.add('popup-side-top');
                    }
                }
            });
        },
    },
    mounted() {
        emitter.on('show-day-hover-info', ({ eventObject, event }) => {
            this.show = false;
            this.eventValues = eventObject;
            this.date = this.eventValues.date.localDate;
            clearTimeout(showDayHoverInfoTimer);
            showDayHoverInfoTimer = setTimeout(() => this.getInfoForDayHoverComponent(event), 1000);
        });
        emitter.on('hide-day-hover-info', () => {
            this.absences = null;
            this.schedule = null;
            clearTimeout(showDayHoverInfoTimer);
            cancel && cancel();
            Object.assign(this.$data, initialEventValuesState());
            this.show = false;
        });
    },
};
</script>
